import api from "../../../../../api/axios"

export default async function submitHRASetup(values, userPlan) {
	const { acknowledge, agreement } = values

	const payload = { inviteCompleted: Boolean(acknowledge) }
	if (agreement === "Yes") payload.accepted = true
	else if (agreement === "No") payload.optOut = true

	const url = `user/plan/onboarding/details/${userPlan.id}`
	const response = await api.post(url, payload)

	return response?.data
}
